import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useWebinarT } from '@/hooks/useWebinarT';
import type { LiveEntryStep } from '@/lib/liveEntryRouting';

export default function LiveEntryError({
  step,
  onRetry,
}: {
  step: LiveEntryStep;
  onRetry?: () => void;
}) {
  const { t } = useWebinarT('webinars');

  return (
    <div
      className="bg-gradient-page-auth h-svh w-full flex flex-col items-center justify-center overflow-hidden px-6"
      aria-live="assertive"
    >
      <div className="flex flex-col items-center gap-8 max-w-lg text-center">
        <img
          src="/assets/welya-splash.png"
          alt="Welya"
          className="w-32 h-32 object-contain opacity-90"
        />

        <div className="space-y-3">
          <h2 className="text-xl font-semibold text-white">{t('live.entryError.title')}</h2>
          <p className="text-sm text-white/80">{t(`live.entryError.step.${step}`)}</p>
        </div>

        <Button
          onClick={onRetry ?? (() => window.location.reload())}
          className="bg-button-primary hover:bg-button-primary/90 text-dark font-semibold px-8 py-6 rounded-full gap-2 shadow-lg"
        >
          <RefreshCw className="size-5" />
          {t('live.entryError.retry')}
        </Button>
      </div>
    </div>
  );
}
